import styled from 'styled-components';
import Button from '../../button';
export const BottomSheetButtonIcon = styled(Button) `
	width: auto;
	border: none;

	&:hover,
	&:active {
		background-color: transparent;
	}

	&:focus {
		border: none;
		box-shadow: none;
	}
`;
